import { toaster } from 'uikit/Toaster'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from 'api'

export const useUpdateDocument = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data) => api.documents.updateItem(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['documentsList'] })

      toaster.create({
        title: 'Документ успешно обновлен',
        type: 'success',
        duration: 3000,
      })
    },
    onError: (error) => {
      toaster.create({
        title: 'Ошибка при обновлении документа',
        description: error.message,
        type: 'error',
        duration: 9000,
      })
    },
  })
}
